import React, { Component } from "react";
import { Nav } from "react-bootstrap";
import { toast } from "react-toastify";
import Paper from "@material-ui/core/Paper";
import { Link, Switch } from "react-router-dom";
import CustomerInfo from "./customerInfo";
import CustomerEquipments from "./customerEquipments";
import CustomerTransactions from "./customerTransactions";
import Sale from "./sale";
import CustomerServices from "./customerServices";
import { getUserById } from "../services/userService";
import { getCustomerAccountBalance } from "../services/transactionService";
import { formatNumber } from "../services/util";
import AdminRoute from "./common/adminRoute";
import CustomerResources from "./customerResources";
import CustomerInvoices from "./customerInvoices";
import Equipment from "./equipment";

class Customer extends Component {
  state = {
    customer: {},
    accountBalance: {},
  };

  async componentDidMount() {
    await this.populateCustomer();
    await this.getAccountBalance();
  }

  async populateCustomer() {
    const { match } = this.props;
    const customerId = match.params.id;

    try {
      const { data: customer } = await getUserById(customerId);
      this.setState({ customer });
    } catch (ex) {
      if (ex.response && ex.response.status >= 400 && ex.response.status < 500) {
        toast.error(ex.response.data);
      }
    }
  }

  async getAccountBalance() {
    const { match } = this.props;
    const customerId = match.params.id;

    try {
      const { data: accountBalance } = await getCustomerAccountBalance(customerId);
      this.setState({ accountBalance });
    } catch (ex) {
      if (ex.response && ex.response.status >= 400 && ex.response.status < 500) {
        toast.error(ex.response.data);
      }
    }
  }

  render() {
    const { customer, accountBalance } = this.state;
    const { match } = this.props;
    const customerId = match.params.id;
    return (
      <Paper elevation={3}>
        <div className="card">
          {
            <h5 className="card-header main-color-bg">
              {customer.fullName} - [Account Balance: &#8358;
              {accountBalance.accountBalance && (0.0 || formatNumber(accountBalance.accountBalance.toFixed(2)))}]
            </h5>
          }
          <div className="card-body">
            <span className="card-text">
              <Nav variant="tabs" className="customTab">
                <Nav.Item>
                  <Link className="nav-link" to={`/customers/${customerId}`}>
                    Information
                  </Link>
                </Nav.Item>
                <Nav.Item>
                  <Link className="nav-link" to={`/customers/${customerId}/equipment`}>
                    Equipment
                  </Link>
                </Nav.Item>
                <Nav.Item>
                  <Link className="nav-link" to={`/customers/${customerId}/services`}>
                    Services
                  </Link>
                </Nav.Item>
                <Nav.Item>
                  <Link className="nav-link" to={`/customers/${customerId}/resources`}>
                    Resources
                  </Link>
                </Nav.Item>
                <Nav.Item>
                  <Link className="nav-link" to={`/customers/${customerId}/sale`}>
                    Sale
                  </Link>
                </Nav.Item>
                <Nav.Item>
                  <Link className="nav-link" to={`/customers/${customerId}/invoices`}>
                    Invoices
                  </Link>
                </Nav.Item>
                <Nav.Item>
                  <Link className="nav-link" to={`/customers/${customerId}/transactions`}>
                    Transactions
                  </Link>
                </Nav.Item>
              </Nav>
              <Switch>
                <AdminRoute path="/customers/:id/equipment/:equipmentId" render={(props) => <Equipment {...props} />} />
                <AdminRoute path="/customers/:id/sale" render={(props) => <Sale {...props} />} />
                <AdminRoute path="/customers/:id/invoices" render={(props) => <CustomerInvoices {...props} />} />
                <AdminRoute path="/customers/:id/services" render={(props) => <CustomerServices {...props} />} />
                <AdminRoute path="/customers/:id/resources" render={(props) => <CustomerResources {...props} />} />
                <AdminRoute path="/customers/:id/equipment" render={(props) => <CustomerEquipments {...props} />} />
                <AdminRoute
                  path="/customers/:id/transactions"
                  render={(props) => <CustomerTransactions {...props} />}
                />
                <AdminRoute path="/customers/:id" render={(props) => <CustomerInfo {...props} />} />
              </Switch>
            </span>
          </div>
        </div>
      </Paper>
    );
  }
}

export default Customer;
